import { render, staticRenderFns } from "./AnotherQuiz.vue?vue&type=template&id=d3c3ce18&scoped=true&"
import script from "./AnotherQuiz.vue?vue&type=script&lang=js&"
export * from "./AnotherQuiz.vue?vue&type=script&lang=js&"
import style0 from "./AnotherQuiz.vue?vue&type=style&index=0&id=d3c3ce18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c3ce18",
  null
  
)

export default component.exports